import React, { useState } from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import TextButton from '~/components/atom/TextButton';
import { Heading3, Label } from '~/components/atom/Typography';
import AnimatedCheckbox from '~/components/molecule/AnimatedCheckbox';
import Overlay from '../ModalsV2/Overlay';
import Modal from '../ModalsV2/Modal';
import Divider from '~/components/atom/Divider';
import Icon, { type IconType } from '~/components/atom/Icon';
import type { ThemeColor } from '~/theme/System/tokens/colorPalette';

const text = {
  dontShowThisAgain: 'Niet meer laten zien',
  confirm: 'Bevestigen',
  cancel: 'Annuleren',
};

export type Props = {
  dataTestId?: string;
  className?: string;
  title: string;
  body: React.ReactNode;
  icon?: { name: IconType; color?: ThemeColor };
  onConfirm: (hideWarning: boolean) => void;
  onCancel: () => void;
};

const DontShowThisAgainModal: React.FCC<Props> = ({
  dataTestId,
  className,
  title,
  body,
  icon = { name: 'alert-octagon', color: { group: 'warning' } },
  onCancel,
  onConfirm,
}) => {
  const [checked, setChecked] = useState(false);

  return (
    <Overlay onClose={onCancel} root="lfa-invoice-warning">
      <Modal maxWidth="900px" onClose={onCancel}>
        <JustificationContainer
          direction="column"
          gap="base"
          margin={['xxl']}
          dataTestId={dataTestId}
          className={className}
        >
          <JustificationContainer align="center" gap="xs">
            <Icon name={icon.name} color={icon.color} size="l" />
            {/* Mirror icon color */}
            <Heading3 margin={[null]} color={icon.color}>
              {title}
            </Heading3>
          </JustificationContainer>
          <Divider margin={['xxs', null, 'm', null]} />
          <JustificationContainer direction="column" gap="s">
            {body}
            <AnimatedCheckbox
              selectable
              label={
                <Label size="base" margin={[null]}>
                  {text.dontShowThisAgain}
                </Label>
              }
              value={checked}
              onChange={() => setChecked(!checked)}
            />
          </JustificationContainer>
          <JustificationContainer
            width="100%"
            margin={['m', null, null, null]}
            gap="base"
            justification="end"
          >
            <TextButton
              label={text.cancel}
              onClick={onCancel}
              size="medium"
              appearance="danger"
            />
            <Button
              label={text.confirm}
              onClick={() => onConfirm(checked)}
              size="medium"
            />
          </JustificationContainer>
        </JustificationContainer>
      </Modal>
    </Overlay>
  );
};

export default DontShowThisAgainModal;
